<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.19 14.72L13.74 12.27L11.6 10.13L9.12 7.65002" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.12 18.96L15.49 14.01L9.83001 8.36005L4.88 14.72L9.12 18.96Z" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.49001 20.6L9.13001 18.96L4.89 14.72L3.25 16.36C2.59 17.02 2.59 18.08 3.25 18.74L5.11001 20.6C5.76001 21.26 6.83001 21.26 7.49001 20.6Z" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.29001 19.13L11.41 21.25" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.61 10.23C14 10.62 14.01 11.25 13.61 11.64C13.53 11.72 13.43 11.8 13.31 11.84L12 10.53C12.04 10.42 12.11 10.32 12.2 10.23C12.6 9.83004 13.22 9.84004 13.61 10.23Z" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M21.25 11.25H19.25" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.91 5.08997L17.2 6.79997" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.75 2.75V4.75" stroke="#233C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'IconMegaphone',
  props: {
    width: {
      type: [String, Number],
      default: 24
    },

    height: {
      type: [String, Number],
      default: 24
    }
  }
};
</script>
